module.exports = __webpack_public_path__ + "static/media/the-aa-logo-charcoal.91cbe796.svg";